<template>
  <div class="addressBox" >
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border >
      <el-table-column label="支出方式" min-width="100">
        <!-- <template slot="header" >
          <div><span class="red">*</span>支出方式</div>
        </template> -->
        <template >
          <div>
            <el-form-item label=""    class="table_error"  prop="expenditurePattern">
              <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择" @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="100">
        <!-- <template slot="header" >
          <div><span class="red">*</span>运费计价</div>
        </template> -->
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="freightPricingType">
              <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价(元)" min-width="100">
        <!-- <template slot="header" >
          <div><span class="red">*</span>运费单价(元)</div>
        </template> -->
        <template >
          <div>
            <div v-if="goodform.expenditurePatternName&&goodform.freightPricingType">
              <el-form-item label=""   class="table_error" prop="freightUnitPrice" v-if="goodform.freightPricingType!=1" >
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
              </el-form-item>
              <span v-else>-</span>
            </div>
            <div v-else>-</div>

            </div>

        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="100">
        <!-- <template slot="header" >
          <div><span class="red">*</span>运费金额(元)</div>
        </template> -->
        <template >
          <div>
            <div v-if="goodform.expenditurePatternName&&goodform.freightPricingType">
              <el-form-item label=""  class="table_error" prop="freightAmount">
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightAmount"  ></el-input>
              </el-form-item>
            </div>
            <div v-else>-</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryDetailList } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      ZHFSlist: [],
      SRJJlist: []
    }
  },
  created () {
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'freightTaxRate', null)
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
  },
  methods: {
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      }
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, this.goodform.freightUnitPrice), 2))
        }
        if (this.goodform.freightAmount && this.goodform.serviceRate) {
          let n = this.goodform.serviceRate / 100
          this.$set(this.goodform, 'serviceCharge', toFixed(accMul(this.goodform.freightAmount, n), 2))
        } else {
          this.$set(this.goodform, 'serviceCharge', '')
        }
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.tableBox{
  width:900px;
}
.addressBox /deep/.el-input__inner{
  width: 100px;
}
</style>
